export interface CmsProtectionDetailsApplianceCarePanelHeader {
  protectionDetailsApplianceCarePanelHeaderSubtitle: string;
  protectionDetailsApplianceCarePanelHeaderTitle: string;
}
